var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ejs-dialog',{ref:"queryDialog",attrs:{"target":_vm.target,"isModal":_vm.isModal,"width":_vm.width,"header":_vm.header,"buttons":_vm.buttonGroup,"showCloseIcon":_vm.showCloseIcon,"animationSettings":_vm.animationSettings,"visible":_vm.visible,"content":_vm.cssClassContent}})
}
var staticRenderFns = []

export { render, staticRenderFns }